import { InjectionToken } from '@angular/core';

export interface SecurityModuleConfig {
  postAuthUrls: string;
  logoutRedirectUri: string;
  loginUrl: string;
  postLoginBackendUrl: string;
}

export const SECURITY_MODULE_CONFIG = new InjectionToken<SecurityModuleConfig>('SECURITY_MODULE_CONFIG');
